import React from 'react';
import { useSelector } from 'react-redux';
import VaccinatedRow from './vaccinatedRow';
import d3 from '../../utils/d3Importer';

// import { numberWithCommas } from '../../utils/functions';

export default function FullyVaccinated() {
  const dataAir = useSelector((state) => state.data.dataAir);

  // DATE_AS_AT
  const formatTime = d3.timeFormat('%d %B, %Y');
  const date = new Date(dataAir.DATE_AS_AT);

  const locations = [
    {
      name: 'Australia',
      key: 'AUS',
      firstDosePerc: dataAir.AIR_AUS_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_AUS_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_AUS_18_PLUS_THIRD_DOSE_PCT,
    },
    {
      name: 'New South Wales',
      key: 'NSW',
      firstDosePerc: dataAir.AIR_NSW_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_NSW_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_NSW_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Victoria',
      key: 'VIC',
      firstDosePerc: dataAir.AIR_VIC_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_VIC_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_VIC_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Western Australia',
      key: 'WA',
      firstDosePerc: dataAir.AIR_WA_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_WA_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_WA_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Queensland',
      key: 'QLD',
      firstDosePerc: dataAir.AIR_QLD_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_QLD_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_QLD_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'South Australia',
      key: 'SA',
      firstDosePerc: dataAir.AIR_SA_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_SA_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_SA_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Tasmania',
      key: 'TAS',
      firstDosePerc: dataAir.AIR_TAS_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_TAS_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_TAS_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Australian Capital Territory',
      key: 'ACT',
      firstDosePerc: dataAir.AIR_ACT_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_ACT_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_ACT_18_PLUS_THIRD_DOSE_PERC,
    },
    {
      name: 'Nothern Territory',
      key: 'NT',
      firstDosePerc: dataAir.AIR_NT_16_PLUS_FIRST_DOSE_PCT,
      secondDosePerc: dataAir.AIR_NT_16_PLUS_SECOND_DOSE_PCT,
      thirdDosePerc: dataAir.AIR_NT_18_PLUS_THIRD_DOSE_PERC,
    },
  ];

  return (
    <>
      <section id="sectionTop">
        <div className="inner-section">
          <h1>Vaccinated Australian population by state and territory</h1>
          <p>
            The percentage of people who have received a COVID-19 vaccine in
            Australia.
            <br />
            <span className="lastUpdated">
              Last updated: {formatTime(date)}
            </span>
          </p>
          <div className="key">
            <div className="oneDoseCirc" />
            <div className="keyText">
              One vaccination (people aged 16 and older)
            </div>
          </div>
          <div className="key">
            <div className="twoDoseCirc" />
            <div className="keyText">
              Two vaccinations (people aged 16 and older)
            </div>
          </div>
          <div className="key">
            <div className="threeDoseCirc" />
            <div className="keyText">
              Three vaccinations (people aged 18 and older)
            </div>
          </div>
          <div className="table-section">
            {locations.map((obj) => {
              return <VaccinatedRow key={obj.key} {...obj} />;
            })}
          </div>
        </div>
      </section>
      <section>
        <div className="source">
          SOURCE:{' '}
          <a href={dataAir.URL} target="_blank" rel="noreferrer">
            Department of Health
          </a>
          , Australian Immunisation Register, ABS.
          <br />
          Booster percentages extraploated from ABS population data and
          department of health totals.
        </div>
      </section>
    </>
  );
}
